import { createEnum } from '../utils/actionTypesHelpers';

export default createEnum(
  {
    add: null,
  },
  'entity',
);
